import { shareColumnsExtend, shareFormColumnsExtend } from './share';
export const ORDER_STATES = [
  'init',
  'pending',
  'rejected',
  'wait_admin_audit',
  'admin_rejected',
  'wait_boss_audit',
  'boss_rejected',
  'wait_supplier_confirm',
  'confirmed',
  'partial',
  'completed',
  'wait_sales_director_audit',
  'wait_supplier_boss_confirm',
  'sales_director_rejected',
  'supplier_boss_rejected',
  'supplier_rejected',
  'fabric_arrived',
  'cutting_updated',
  'printing_in_progress',
  'workshop_in_progress',
  'tail_in_progress',
]

export const ORDER_ACCESSORY_STATES = [
  'needless',
  'pending',
  'submited',
  'received',
  'rejected',
  'confirmed',
  'need',
]

export const ORDER_DELIVERY_CHANGE_REQUEST_STATES = [
  'init',
  'pending',
  'approved',
  'rejected',
]

export const ORDER_OVERDUE_STATUSES = [
  'not_overdue',
  'delivered',
  'overdue',
]

export const ORDER_CUSTOMER_LEVELS = [
  's',
  'a',
  'b',
]

export const ORDER_QUALITY_REQUIREMENTS = [
  'customized',
  'brand',
]

const entityColumns = {
  id: {
    model_name: 'Order',
    column_type: 'id',
    label_key_path: 'order.id',
  },
  created_at: {
    model_name: 'Order',
    column_type: 'datetime',
    label_key_path: 'order.createdAt',
  },
  updated_at: {
    model_name: 'Order',
    column_type: 'datetime',
    label_key_path: 'order.updatedAt',
  },
  number: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.number',
  },
  overdue_reason: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.overdueReason',
  },
  reject_reason: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.rejectReason',
  },
  remark: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.remark',
  },
  internal_remark: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.internalRemark',
  },
  company: {
    model_name: 'Order',
    column_type: 'belongs_to',
    label_key_path: 'order.company',
    extra: {
      association_name: 'company',
      model_name: 'Company',
      foreign_key: 'company_id',
      display_column: 'name',
    },
  },
  company_id: {
    model_name: 'Order',
    column_type: 'belongs_to',
    label_key_path: 'order.company',
    extra: {
      association_name: 'company',
      model_name: 'Company',
      foreign_key: 'company_id',
      display_column: 'name',
    },
  },
  creator: {
    model_name: 'Order',
    column_type: 'belongs_to',
    label_key_path: 'order.creator',
    extra: {
      association_name: 'creator',
      model_name: 'User',
      foreign_key: 'creator_id',
      display_column: 'screen_name',
    },
  },
  creator_id: {
    model_name: 'Order',
    column_type: 'belongs_to',
    label_key_path: 'order.creator',
    extra: {
      association_name: 'creator',
      model_name: 'User',
      foreign_key: 'creator_id',
      display_column: 'screen_name',
    },
  },
  merchandiser: {
    model_name: 'Order',
    column_type: 'belongs_to',
    label_key_path: 'order.merchandiser',
    extra: {
      association_name: 'merchandiser',
      model_name: 'User',
      foreign_key: 'merchandiser_id',
      display_column: 'screen_name',
    },
  },
  merchandiser_id: {
    model_name: 'Order',
    column_type: 'belongs_to',
    label_key_path: 'order.merchandiser',
    extra: {
      association_name: 'merchandiser',
      model_name: 'User',
      foreign_key: 'merchandiser_id',
      display_column: 'screen_name',
    },
  },
  product: {
    model_name: 'Order',
    column_type: 'belongs_to',
    label_key_path: 'order.product',
    extra: {
      association_name: 'product',
      model_name: 'Product',
      foreign_key: 'product_id',
      display_column: 'name',
    },
  },
  product_id: {
    model_name: 'Order',
    column_type: 'belongs_to',
    label_key_path: 'order.product',
    extra: {
      association_name: 'product',
      model_name: 'Product',
      foreign_key: 'product_id',
      display_column: 'name',
    },
  },
  quantity: {
    model_name: 'Order',
    column_type: 'integer',
    label_key_path: 'order.quantity',
  },
  state: {
    model_name: 'Order',
    column_type: 'enum',
    extra: {
      options: ['init', 'pending', 'rejected', 'wait_admin_audit', 'admin_rejected', 'wait_boss_audit', 'boss_rejected', 'wait_supplier_confirm', 'confirmed', 'partial', 'completed', 'wait_sales_director_audit', 'wait_supplier_boss_confirm', 'sales_director_rejected', 'supplier_boss_rejected', 'supplier_rejected', 'fabric_arrived', 'cutting_updated', 'printing_in_progress', 'workshop_in_progress', 'tail_in_progress'],
    },
    label_key_path: 'order.state',
  },
  delivery_on: {
    model_name: 'Order',
    column_type: 'date',
    label_key_path: 'order.deliveryOn',
  },
  delivery_remark: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.deliveryRemark',
  },
  plan_completed_on: {
    model_name: 'Order',
    column_type: 'date',
    label_key_path: 'order.planCompletedOn',
  },
  audited_at: {
    model_name: 'Order',
    column_type: 'datetime',
    label_key_path: 'order.auditedAt',
  },
  completed_at: {
    model_name: 'Order',
    column_type: 'datetime',
    label_key_path: 'order.completedAt',
  },
  confirmed_at: {
    model_name: 'Order',
    column_type: 'datetime',
    label_key_path: 'order.confirmedAt',
  },
  order_at: {
    model_name: 'Order',
    column_type: 'datetime',
    label_key_path: 'order.orderAt',
  },
  receive_cloth_on: {
    model_name: 'Order',
    column_type: 'date',
    label_key_path: 'order.receiveClothOn',
  },
  receive_cloth_remark: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.receiveClothRemark',
  },
  printing_start_on: {
    model_name: 'Order',
    column_type: 'date',
    label_key_path: 'order.printingStartOn',
  },
  printing_remark: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.printingRemark',
  },
  workshop_start_on: {
    model_name: 'Order',
    column_type: 'date',
    label_key_path: 'order.workshopStartOn',
  },
  workshop_remark: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.workshopRemark',
  },
  tail_start_on: {
    model_name: 'Order',
    column_type: 'date',
    label_key_path: 'order.tailStartOn',
  },
  tail_remark: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.tailRemark',
  },
  overdue_state: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.overdueState',
  },
  supplier: {
    model_name: 'Order',
    column_type: 'belongs_to',
    label_key_path: 'order.supplier',
    extra: {
      association_name: 'supplier',
      model_name: 'User',
      foreign_key: 'supplier_id',
      display_column: 'screen_name',
    },
  },
  supplier_id: {
    model_name: 'Order',
    column_type: 'belongs_to',
    label_key_path: 'order.supplier',
    extra: {
      association_name: 'supplier',
      model_name: 'User',
      foreign_key: 'supplier_id',
      display_column: 'screen_name',
    },
  },
  supplier_remark: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.supplierRemark',
  },
  factory: {
    model_name: 'Order',
    column_type: 'belongs_to',
    label_key_path: 'order.factory',
    extra: {
      association_name: 'factory',
      model_name: 'Factory',
      foreign_key: 'factory_id',
      display_column: 'name',
    },
  },
  factory_id: {
    model_name: 'Order',
    column_type: 'belongs_to',
    label_key_path: 'order.factory',
    extra: {
      association_name: 'factory',
      model_name: 'Factory',
      foreign_key: 'factory_id',
      display_column: 'name',
    },
  },
  factory_remark: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.factoryRemark',
  },
  is_push_to_jushuitan: {
    model_name: 'Order',
    column_type: 'boolean',
    label_key_path: 'order.isPushToJushuitan',
  },
  supplier_first_reject_reason: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.supplierFirstRejectReason',
  },
  supplier_boss_first_reject_reason: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.supplierBossFirstRejectReason',
  },
  virtual_warehouse: {
    model_name: 'Order',
    column_type: 'belongs_to',
    label_key_path: 'order.virtualWarehouse',
    extra: {
      association_name: 'virtual_warehouse',
      model_name: 'VirtualWarehouse',
      foreign_key: 'virtual_warehouse_id',
      display_column: 'name',
    },
  },
  virtual_warehouse_id: {
    model_name: 'Order',
    column_type: 'belongs_to',
    label_key_path: 'order.virtualWarehouse',
    extra: {
      association_name: 'virtual_warehouse',
      model_name: 'VirtualWarehouse',
      foreign_key: 'virtual_warehouse_id',
      display_column: 'name',
    },
  },
  liquidated_damages: {
    model_name: 'Order',
    column_type: 'decimal',
    label_key_path: 'order.liquidatedDamages',
  },
  accessory_state: {
    model_name: 'Order',
    column_type: 'enum',
    extra: {
      options: ['needless', 'pending', 'submited', 'received', 'rejected', 'confirmed', 'need'],
    },
    label_key_path: 'order.accessoryState',
  },
  need_accessory: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.needAccessory',
  },
  fabric_cost: {
    model_name: 'Order',
    column_type: 'decimal',
    label_key_path: 'order.fabricCost',
  },
  craft_cost: {
    model_name: 'Order',
    column_type: 'decimal',
    label_key_path: 'order.craftCost',
  },
  processing_cost: {
    model_name: 'Order',
    column_type: 'decimal',
    label_key_path: 'order.processingCost',
  },
  assist_cost: {
    model_name: 'Order',
    column_type: 'decimal',
    label_key_path: 'order.assistCost',
  },
  management_cost: {
    model_name: 'Order',
    column_type: 'decimal',
    label_key_path: 'order.managementCost',
  },
  cost_price: {
    model_name: 'Order',
    column_type: 'decimal',
    label_key_path: 'order.costPrice',
  },
  accessory_reach_on: {
    model_name: 'Order',
    column_type: 'date',
    label_key_path: 'order.accessoryReachOn',
  },
  is_pre_order: {
    model_name: 'Order',
    column_type: 'boolean',
    label_key_path: 'order.isPreOrder',
  },
  requested_delivery_on: {
    model_name: 'Order',
    column_type: 'date',
    label_key_path: 'order.requestedDeliveryOn',
  },
  delivery_change_request_reject_reason: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.deliveryChangeRequestRejectReason',
  },
  delivery_change_request_state: {
    model_name: 'Order',
    column_type: 'enum',
    extra: {
      options: ['init', 'pending', 'approved', 'rejected'],
    },
    label_key_path: 'order.deliveryChangeRequestState',
  },
  delivery_change_request_remarks: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.deliveryChangeRequestRemarks',
  },
  cutting_threshold_percent: {
    model_name: 'Order',
    column_type: 'integer',
    label_key_path: 'order.cuttingThresholdPercent',
  },
  cutting_grace_hours: {
    model_name: 'Order',
    column_type: 'integer',
    label_key_path: 'order.cuttingGraceHours',
  },
  overdue_status: {
    model_name: 'Order',
    column_type: 'enum',
    extra: {
      options: ['not_overdue', 'delivered', 'overdue'],
    },
    label_key_path: 'order.overdueStatus',
  },
  watch: {
    model_name: 'Order',
    column_type: 'boolean',
    label_key_path: 'order.watch',
  },
  sales_director: {
    model_name: 'Order',
    column_type: 'belongs_to',
    label_key_path: 'order.salesDirector',
    extra: {
      association_name: 'sales_director',
      model_name: 'User',
      foreign_key: 'sales_director_id',
      display_column: 'screen_name',
    },
  },
  sales_director_id: {
    model_name: 'Order',
    column_type: 'belongs_to',
    label_key_path: 'order.salesDirector',
    extra: {
      association_name: 'sales_director',
      model_name: 'User',
      foreign_key: 'sales_director_id',
      display_column: 'screen_name',
    },
  },
  line_items: {
    model_name: 'Order',
    column_type: 'has_many',
    label_key_path: 'order.lineItems',
    extra: {
      association_name: 'line_items',
      model_name: 'LineItem',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  line_item_ids: {
    model_name: 'Order',
    column_type: 'has_many',
    label_key_path: 'order.lineItems',
    extra: {
      association_name: 'line_items',
      model_name: 'LineItem',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  purchase_order: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.purchaseOrder',
  },
  deliveries: {
    model_name: 'Order',
    column_type: 'has_many',
    label_key_path: 'order.deliveries',
    extra: {
      association_name: 'deliveries',
      model_name: 'Delivery',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  delivery_ids: {
    model_name: 'Order',
    column_type: 'has_many',
    label_key_path: 'order.deliveries',
    extra: {
      association_name: 'deliveries',
      model_name: 'Delivery',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  pre_production_meeting_minutes: {
    model_name: 'Order',
    column_type: 'text',
    label_key_path: 'order.preProductionMeetingMinutes',
  },
  customer_level: {
    model_name: 'Order',
    column_type: 'enum',
    extra: {
      options: ['s', 'a', 'b'],
    },
    label_key_path: 'order.customerLevel',
  },
  quality_requirement: {
    model_name: 'Order',
    column_type: 'enum',
    extra: {
      options: ['customized', 'brand'],
    },
    label_key_path: 'order.qualityRequirement',
  },
  total_product_cost: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.totalProductCost',
  },
  can_update: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.canUpdate',
  },
  can_merchandiser_approve: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.canMerchandiserApprove',
  },
  can_merchandiser_reject: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.canMerchandiserReject',
  },
  can_salesman_submit: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.canSalesmanSubmit',
  },
  can_sales_director_approve: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.canSalesDirectorApprove',
  },
  abilities: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.abilities',
  },
  cutting_records: {
    model_name: 'Order',
    column_type: 'has_many',
    label_key_path: 'order.cuttingRecords',
    extra: {
      association_name: 'cutting_records',
      model_name: 'CuttingRecord',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  cutting_record_ids: {
    model_name: 'Order',
    column_type: 'has_many',
    label_key_path: 'order.cuttingRecords',
    extra: {
      association_name: 'cutting_records',
      model_name: 'CuttingRecord',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  line_items_attributes: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.lineItemsAttributes',
  },
  order_cutting_dates: {
    model_name: 'Order',
    column_type: 'has_many',
    label_key_path: 'order.orderCuttingDates',
    extra: {
      association_name: 'order_cutting_dates',
      model_name: 'OrderCuttingDate',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  order_cutting_date_ids: {
    model_name: 'Order',
    column_type: 'has_many',
    label_key_path: 'order.orderCuttingDates',
    extra: {
      association_name: 'order_cutting_dates',
      model_name: 'OrderCuttingDate',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  order_cutting_remark: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.orderCuttingRemark',
  },
  state_operation_logs: {
    model_name: 'Order',
    column_type: 'has_many',
    label_key_path: 'order.stateOperationLogs',
    extra: {
      association_name: 'state_operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  state_operation_log_ids: {
    model_name: 'Order',
    column_type: 'has_many',
    label_key_path: 'order.stateOperationLogs',
    extra: {
      association_name: 'state_operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  accessory_state_operation_logs: {
    model_name: 'Order',
    column_type: 'has_many',
    label_key_path: 'order.accessoryStateOperationLogs',
    extra: {
      association_name: 'accessory_state_operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  accessory_state_operation_log_ids: {
    model_name: 'Order',
    column_type: 'has_many',
    label_key_path: 'order.accessoryStateOperationLogs',
    extra: {
      association_name: 'accessory_state_operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  files: {
    model_name: 'Order',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'order.files',
  },
  files_with_audio: {
    model_name: 'Order',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'order.filesWithAudio',
  },
  order_accessory_deliveries: {
    model_name: 'Order',
    column_type: 'has_many',
    label_key_path: 'order.orderAccessoryDeliveries',
    extra: {
      association_name: 'order_accessory_deliveries',
      model_name: 'OrderAccessoryDelivery',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  order_accessory_delivery_ids: {
    model_name: 'Order',
    column_type: 'has_many',
    label_key_path: 'order.orderAccessoryDeliveries',
    extra: {
      association_name: 'order_accessory_deliveries',
      model_name: 'OrderAccessoryDelivery',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  merchandiser_inspection_remark: {
    model_name: 'Order',
    column_type: 'string',
    label_key_path: 'order.merchandiserInspectionRemark',
  },
  merchandiser_inspection_remark_images: {
    model_name: 'Order',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'order.merchandiserInspectionRemarkImages',
  },
  merchandiser_inspection_remark_images_with_audio: {
    model_name: 'Order',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'order.merchandiserInspectionRemarkImagesWithAudio',
  },
  pre_production_meeting_images: {
    model_name: 'Order',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 20,
    },
    label_key_path: 'order.preProductionMeetingImages',
  },
  pre_production_meeting_images_with_audio: {
    model_name: 'Order',
    column_type: 'attached',
    extra: {
      limit: 9,
      accept: 'audio/*',
      type: 'audio',
      size: 20,
    },
    label_key_path: 'order.preProductionMeetingImagesWithAudio',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
